import { Injectable, inject } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, of, tap, throwError } from 'rxjs';
import { environment } from './../../environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpCacheService } from './cache.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private cacheService = inject(HttpCacheService);
	private nzMessageService = inject(NzMessageService);


	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		let baseUrl = environment.baseApiUrl;
		if (request.url.includes('ApplicantProtected/UploadVideoResume')) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${localStorage.getItem('token')}`
				},
				url: `${environment.azureApiUrl}/${request.url}`
			});
		} else if (request.url.includes('ip.cloudstaff.tech/json')) {
			request = request.clone({
				url: `${request.url}`
			});
		} else {
			request = request.clone({
				url: `${baseUrl}/${request.url}`
			});
		}

		// attempt to retrieve a cached response
		const cachedResponse: HttpResponse<any> = this.cacheService.get(
			request.url
		);

		// return cached response
		if (cachedResponse?.url) {
			return of(cachedResponse);
		}

		return next.handle(request).pipe(
			tap((event) => {
				if (event instanceof HttpResponse && request.method == 'GET') {
					this.cacheService.put(request.url, event);
				}
			}),

			catchError((error: HttpErrorResponse) => {
				let errorMessage = '';
				if (error.error instanceof ErrorEvent) {
					// client-side error
					errorMessage = `Error: ${error.error.message}`;
				} else {
					// server-side error
					if (error.status == 401 || error.status == 403) {
						const err =
							error.status == 403
								? error.error
								: 'You have an administrator account. Please go to jobs-admin.cloudstaff.com to login.';
						this.nzMessageService.error(err);
					} else if (error.status === 409) {
						this.nzMessageService.error(
							"Sorry, we can't find this email. Please create an account to login." +
								error.error
						);
					} else if (error.status === 400) {
						this.nzMessageService.error(error.error);
					}
				}

				errorMessage = error.error;
				return throwError(() => errorMessage);
			})
		);
	}
}
